import { IMatchReportsHome, MatchReportsHome } from "@sky-it-livedata/livedata-sports-design-system";

import { WidgetContext } from "../../types/WidgetContext";
import { log } from "../../utils/log";
import { MatchReportsQuery } from "./types";

import transformer from "./transformers/query";
import { useIntcmp } from "../../hooks/useIntcmp";

export const setCustomAttributes = ({
  variables,
}: WidgetContext<MatchReportsQuery>) => {
  return {
    variables: JSON.stringify(variables),
  };
};

export const getServerProps = ({
  props,
}: WidgetContext<MatchReportsQuery>): IMatchReportsHome => {
  return transformer(props);
}


const matchReportsWidget = ({props, ...rest}:WidgetContext<IMatchReportsHome>) => {
    log({ props, ...rest });

    const intCmpEventHandler = useIntcmp();

    return (
        <div onClick={intCmpEventHandler}>
            <MatchReportsHome {...props} />
        </div>
    );
}

export default matchReportsWidget;